import { useEffect } from "react";

export const LoaderRemover = () => {
  useEffect(() => {
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => loader.remove(), 300); // match your CSS transition
    }
  }, []);
  return null
}